export default "__VITE_ASSET__BGntVgDH__"